import * as React from 'react'
import * as ReactDOM from 'react-dom'
import classnames from 'classnames'
import getUrl from 'airship/modules/get-url'
import * as store from './store'
import {Project, EngageApp, ReachProject} from 'airship/page/app_list/types'
import {isEngageApp} from 'airship/page/app_list/lib/run-filter'
import Popover from '../popover/react'

const EngageListItem: React.SFC<{project: EngageApp}> = ({project}) => {
  const style: React.CSSProperties = {}
  const isProd = project.type === 'production'

  if (project.icon) {
    style.backgroundImage = `url(${project.icon})`
  }

  return (
    <li>
      <a href={project.url}>
        <div className="app-icon" style={style} />
        <h3>{project.name}</h3>
        <p>
          <span
            className={classnames('meta', isProd ? 'meta-prod' : 'meta-dev')}
          >
            {isProd ? 'Live' : 'Test'}
          </span>
          {project.shared && (
            <span className="meta meta-team">&bull; Team</span>
          )}
        </p>
      </a>
    </li>
  )
}

const ReachListItem: React.SFC<{project: ReachProject}> = ({project}) => {
  const urlName = 'reach_page:wallet_dashboard'
  const url = getUrl(urlName, project._meta.companyId, project.contextId)
  return (
    <li>
      <a href={url}>
        <div className="app-icon">
          <svg className="app-navigator__type">
            <use
              xmlnsXlink="http://www.w3.org/1999/xlink"
              xlinkHref={`#reach-project-type-${project.projectType}`}
            />
          </svg>
        </div>
        <h3>{project.name}</h3>
        <p>
          <span className="meta meta-prod">{project._meta.friendlyType}</span>
        </p>
      </a>
    </li>
  )
}

export default function (el?: HTMLElement): void {
  if (!el?.dataset.project) {
    return
  }

  const currentProject = JSON.parse(el.dataset.project) as Project

  const key = isEngageApp(currentProject)
    ? currentProject.key
    : currentProject.contextId

  store.add(currentProject)

  const recentProjects = store.list(key)

  if (recentProjects.length < 1) {
    return
  }

  const trigger = (
    <a className="app-toggle" aria-label="Switch between your recent projects">
      <svg className="svg-sprite">
        <use
          xmlnsXlink="http://www.w3.org/1999/xlink"
          xlinkHref="#caret-down"
        />
      </svg>
    </a>
  )

  const projectLis = recentProjects.map((project) => {
    if (isEngageApp(project)) {
      return <EngageListItem key={project.key} project={project} />
    }

    return <ReachListItem key={project.contextId} project={project} />
  })

  const render = (
    <Popover
      trigger={trigger}
      noArrow={true}
      popoverClass="popover no-arrow-popover-content projects-select"
    >
      <div className="appselect-content">
        <ul id="id_menu_app_list">{projectLis}</ul>
        <a href="/apps/" className="btn">
          View all projects
        </a>
      </div>
    </Popover>
  )

  ReactDOM.render(render, el)
}
